var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.473 13.1159L16.4487 14.1402H17.8972H21.7484C25.9395 14.1402 29.4561 17.9515 29.4561 22.7711C29.4561 27.5296 25.5838 31.402 20.8253 31.402C20.4948 31.402 20.1778 31.2707 19.9441 31.037C19.7104 30.8033 19.5791 30.4863 19.5791 30.1558C19.5791 29.8253 19.7104 29.5083 19.9441 29.2746C20.1778 29.0409 20.4948 28.9096 20.8253 28.9096C24.2102 28.9096 26.9638 26.156 26.9638 22.7711C26.9638 19.4933 24.7235 16.6326 21.7484 16.6326H17.8972H16.4487L17.473 17.6568L19.8601 20.0439L19.8604 20.0443C19.9762 20.1599 20.0681 20.2971 20.1307 20.4482C20.1934 20.5993 20.2256 20.7613 20.2256 20.9249C20.2256 21.0885 20.1934 21.2505 20.1307 21.4016C20.0681 21.5527 19.9762 21.6899 19.8604 21.8055L19.8589 21.8071C19.7436 21.9231 19.6065 22.0151 19.4555 22.0779C19.3045 22.1407 19.1426 22.173 18.9791 22.173C18.8156 22.173 18.6537 22.1407 18.5027 22.0779C18.3517 22.0151 18.2146 21.9231 18.0993 21.8071L18.0981 21.8059L11.6786 15.3864L18.0981 8.96687C18.3318 8.73322 18.6487 8.60195 18.9791 8.60195C19.3095 8.60195 19.6264 8.73322 19.8601 8.96687C20.0937 9.20052 20.225 9.51742 20.225 9.84785C20.225 10.1783 20.0937 10.4952 19.8601 10.7288L17.473 13.1159Z",
    fill: "#146C94",
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevert);
export default __webpack_public_path__ + "static/media/revert.84693c09fc239f43e2e456b989f7e4c0.svg";
export { ForwardRef as ReactComponent };